import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=54058aca&scoped=true&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=54058aca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54058aca",
  null
  
)

export default component.exports